import { ReactNode, createContext, useContext } from 'react'

import { useQuery } from '@tanstack/react-query'
import { AnyRouter, RouteApi, getRouteApi } from '@tanstack/react-router'
import { DocTemplateList } from '~bank-document-templates/types'

import { templatesListQueryOptions } from '../query'

type TemplatesListContextValue = {
  routeApi: RouteApi<'/_app/document-templates/', AnyRouter>
  data: DocTemplateList
  isLoading: boolean
}

const TemplatesListContext = createContext<TemplatesListContextValue | undefined>(undefined)

export const useTemplatesListContext = () => {
  const context = useContext(TemplatesListContext)
  if (!context) {
    throw new Error('useTemplateManageContext must be used within a TemplateManageContext.Provider')
  }
  return context
}

export const TemplatesListContextProvider = ({ children }: { children: ReactNode }) => {
  const routeApi = getRouteApi('/_app/document-templates/')
  const search = routeApi.useSearch()
  const { data, isFetching, isRefetching } = useQuery<DocTemplateList>(templatesListQueryOptions(search))

  if (!data) return null

  return (
    <TemplatesListContext.Provider value={{ routeApi, data, isLoading: isFetching || isRefetching }}>
      {children}
    </TemplatesListContext.Provider>
  )
}
